import { useRef, useState } from 'react';
import PlayPause from '@/components/PlayPause';
import VideoViewer from '@/components/VideoViewer';
import { PageData } from '@/gem.types';

interface Props {
  element: any;
  theme: PageData['theme'];
  contactUrl: {
    userId: string;
    contactId: string;
  };
  gemEndpoint: string;
}

const VideoGemElement = ({ element, theme, contactUrl, gemEndpoint }: Props) => {
  const [playerState, setPlayerState] = useState<'playing' | 'paused'>('paused');
  const [viewerOpen, setViewerOpen] = useState(false);
  const [iframeUrl, setIframeUrl] = useState<string | null>(null);
  const imageRef = useRef<HTMLImageElement>(null);

  const { gem } = element;
  const image = `https://image.mux.com/${gem.playbackId}/animated.gif`;
  const url = `/${gem?.shortId}?ref=${gem?.gemId}`;

  const handlePlayPauseClick = () => {
    setPlayerState('playing');
    setTimeout(() => {
      setPlayerState('paused');
    }, 1000);
  };

  const handleGemClick = () => {
    setViewerOpen(true);
    setIframeUrl(url);
  };

  const renderPreview = () => {
    if (gem.type === 'product') {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      const imageToRender = gem.ogImage || gem.uri;
      if (!imageToRender) {
        return (
          <div
            className="mb-2 font-semibold cursor-pointer"
            style={{ color: theme.containerTextColor }}
          >
            {gem.name}
          </div>
        );
      }
    }

    return (
      <>
        <div
          className="relative w-full flex items-center justify-center"
          style={{
            backgroundImage: `url(${image})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundColor: '#000',
            height: window.innerHeight * 0.35,
            cursor: 'default',
            maxHeight: '70vh'
          }}
        >
          <img ref={imageRef} src={image} alt="" style={{ display: 'none' }} />
          <PlayPause state={playerState} onClick={handlePlayPauseClick} height={160} width={160} />
        </div>
      </>
    );
  };

  const renderViewer = () => {
    return (
      <VideoViewer
        isOpen={viewerOpen}
        onClose={() => setViewerOpen(false)}
        url={iframeUrl || ''}
        theme={theme}
        gem={gem}
        contactUrl={contactUrl}
        gemEndpoint={gemEndpoint}
      />
    );
  };

  return (
    <>
      <div
        className="transition-all duration-300 ease-in-out w-full mb-10 cursor-pointer"
        onClick={handleGemClick}
      >
        {renderPreview()}
      </div>
      {renderViewer()}
    </>
  );
};

export default VideoGemElement;
